"use client";

import { Paragraph } from "@ui/paragraph";
import { LightbulbOff } from "lucide-react";
import {
  setLightsourceParam,
  useLightsourceParam,
} from "../utils/lightsourceSelection";

export default function ProductLightsourceNoop({
  lightsourceParam,
  noLightsourceLabel,
}: {
  lightsourceParam: string | null;
  noLightsourceLabel: string;
}) {
  const param = useLightsourceParam(lightsourceParam);
  const checked = !param || param === "no-lightsource";

  function handleChange() {
    if (checked) return;
    setLightsourceParam("no-lightsource");
  }

  return (
    <label
      htmlFor="no-lightsource"
      className="grid grid-cols-[96px_auto_1fr] items-center gap-x-4"
    >
      <div className="flex size-24 items-center justify-center bg-gray-100">
        <LightbulbOff className="size-8 text-gray-500" />
      </div>
      <input
        type="checkbox"
        id="no-lightsource"
        value="no-lightsource"
        checked={checked}
        onChange={handleChange}
        className="accent-black"
      />
      <Paragraph>{noLightsourceLabel}</Paragraph>
    </label>
  );
}
